import React from 'react';
import { PlusIcon, EyeIcon, EditIcon, TrashIcon, CheckCircleIcon } from 'lucide-react';
import type { TaxType } from './TaxTypeManagement';
export function TaxTypesList({
  globalTaxTypes,
  orgUnitTaxTypes,
  onAdd,
  onEdit,
  onDelete,
  locale = 'en-US'
}) {
  // Combine all tax types into a single list
  const allTaxTypes = [...globalTaxTypes, ...orgUnitTaxTypes];
  return <div className="bg-white shadow rounded-lg" data-id="element-12721">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200" data-id="element-12722">
        <div className="flex items-center justify-between" data-id="element-12723">
          <div data-id="element-12724">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-12725">
              Tax Types
            </h3>
            <p className="mt-1 text-sm text-gray-500" data-id="element-12726">
              Manage tax type definitions used across the organization
            </p>
          </div>
          <button onClick={onAdd} className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-12727">
            <PlusIcon className="h-4 w-4 mr-2" data-id="element-12728" />
            Add Tax Type
          </button>
        </div>
      </div>

      {allTaxTypes.length === 0 ? <div className="px-4 py-12 text-center" data-id="element-12729">
          <p className="text-sm text-gray-500" data-id="element-12730">No tax types configured.</p>
        </div> : <div className="overflow-x-auto" data-id="element-12731">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-12732">
            <thead className="bg-gray-50" data-id="element-12733">
              <tr data-id="element-12734">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12735">
                  Code
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12736">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12737">
                  Description
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12738">
                  Status
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12739">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-12740">
              {allTaxTypes.map(taxType => <tr key={taxType.id} className="hover:bg-gray-50" data-id="element-12741">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-12742">
                    {taxType.code}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-12743">
                    {taxType.name}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500" data-id="element-12744">
                    {taxType.description}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-12745">
                    {taxType.isActive ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-12746">
                        <CheckCircleIcon className="h-3 w-3 mr-1" data-id="element-12747" />
                        Active
                      </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-12748">
                        Inactive
                      </span>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-12749">
                    <div className="flex justify-end space-x-3" data-id="element-12750">
                      <button onClick={() => onEdit(taxType)} className="text-indigo-600 hover:text-indigo-900" title="Edit" data-id="element-12751">
                        <EditIcon className="h-4 w-4" data-id="element-12752" />
                        <span className="sr-only" data-id="element-12753">Edit</span>
                      </button>
                      <button onClick={() => onDelete(taxType.id)} className="text-red-600 hover:text-red-900" title="Delete" data-id="element-12754">
                        <TrashIcon className="h-4 w-4" data-id="element-12755" />
                        <span className="sr-only" data-id="element-12756">Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>}
    </div>;
}